import React from 'react';
import styles from './info-btn.module.css';

export function InfoBtn({ onClick = () => {}, className = '', disabled = false, ariaLabel = 'More information' }) {
  return (
    <button
      className={`${styles.infoBtn} ${className}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      type="button"
    >
      <span className={styles.infoBtn__icon}>i</span>
    </button>
  );
}

export default InfoBtn;
